import { Link } from "wouter";
import Icon from "@/components/mnf/Icon";
import { Btn, PillTag } from "@/components/mnf/UI";
import Logo from "@/components/mnf/Logo";

export default function ShareGrace() {
  return (
    <>
      {/* Header */}
      <div className="px-5 pt-3 pb-2 flex items-center justify-between" style={{ color: "var(--mnf-f)" }}>
        <Link href="/flourish" className="flex items-center gap-2 hover-elevate rounded-full pl-1 pr-3 py-1 no-underline" style={{ color: "var(--mnf-f)" }}>
          <Icon name="arrow_back" size={20} />
          <span className="mnf-serif italic" style={{ fontSize: 17 }}>Share Grace</span>
        </Link>
        <button className="flex items-center justify-center hover-elevate" style={{ width: 36, height: 36, borderRadius: "50%", background: "rgba(30,74,53,0.08)", color: "var(--mnf-f)" }}>
          <Icon name="settings" size={18} filled />
        </button>
      </div>

      <div className="px-5 pt-2 pb-6 space-y-4">
        {/* Verse card */}
        <div
          className="relative overflow-hidden"
          style={{
            borderRadius: 28,
            aspectRatio: "9/15",
            color: "#F5F0E8",
            boxShadow: "0 18px 40px rgba(30,74,53,0.22)",
            background:
              "linear-gradient(180deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.25) 30%, rgba(0,0,0,0.55) 100%), " +
              "radial-gradient(120% 70% at 50% 30%, #3a5a3f 0%, #213d2a 50%, #0d1d14 100%)",
          }}
        >
          {/* tree silhouettes */}
          <svg viewBox="0 0 360 600" className="absolute inset-0 w-full h-full" preserveAspectRatio="xMidYMax slice">
            <defs>
              <linearGradient id="haze" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stopColor="rgba(245,220,180,0.22)" />
                <stop offset="40%" stopColor="rgba(245,220,180,0.06)" />
                <stop offset="100%" stopColor="rgba(0,0,0,0)" />
              </linearGradient>
            </defs>
            <rect width="360" height="600" fill="url(#haze)" />
            {/* trees */}
            {[20, 80, 130, 200, 260, 320].map((x, i) => (
              <rect key={i} x={x} y={120 + (i % 3) * 14} width={i % 2 === 0 ? 12 : 8} height={500} fill={i % 2 === 0 ? "#0a1810" : "#142a1c"} opacity={0.85} rx="2" />
            ))}
            {/* moss / undergrowth */}
            <ellipse cx="180" cy="540" rx="220" ry="60" fill="#1c3623" opacity="0.9" />
            <ellipse cx="80" cy="560" rx="120" ry="40" fill="#264a30" opacity="0.55" />
            <ellipse cx="280" cy="560" rx="120" ry="40" fill="#264a30" opacity="0.55" />
            {/* light rays */}
            <polygon points="120,0 200,0 230,240 110,240" fill="rgba(245,220,180,0.10)" />
            <polygon points="200,0 280,0 250,240 180,240" fill="rgba(245,220,180,0.06)" />
          </svg>

          {/* content */}
          <div className="relative h-full flex flex-col items-center justify-between p-6 text-center">
            <div className="flex items-center justify-center mt-2">
              <PillTag tone="forest">
                <span style={{ color: "#F5F0E8" }}>Daily Nourishment</span>
              </PillTag>
            </div>

            <div>
              <span className="mnf-serif" style={{ fontSize: 64, lineHeight: 0.4, color: "rgba(245,240,232,0.7)", display: "inline-block" }}>“</span>
              <p className="mnf-serif italic mt-3" style={{ fontSize: 22, lineHeight: 1.35, color: "#F5F0E8", letterSpacing: "0.005em" }}>
                "The Lord will guide you continually, giving you water when you are dry and
                restoring your strength. You will be like a well-watered garden, like an
                ever-flowing spring."
              </p>
            </div>

            <div className="flex flex-col items-center gap-1">
              <p className="text-[11px] mnf-body uppercase" style={{ color: "rgba(245,240,232,0.85)", letterSpacing: "0.32em", fontWeight: 700 }}>
                Isaiah 58:11
              </p>
              <p className="mnf-serif italic" style={{ fontSize: 26, color: "#F5F0E8", fontWeight: 500 }}>
                Flourish
              </p>
              <p className="text-[10px] mnf-body uppercase" style={{ color: "rgba(245,240,232,0.6)", letterSpacing: "0.5em" }}>
                Move · Nourish · Flourish
              </p>
              <div className="mt-3 flex items-center gap-2">
                <div style={{ background: "#fff", padding: 6, borderRadius: 8 }}>
                  <Logo size={20} className="text-[#1E4A35]" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center text-[11px] mnf-body uppercase" style={{ color: "var(--mnf-tg)", letterSpacing: "0.18em", fontWeight: 600 }}>
          <Icon name="auto_awesome" size={11} color="var(--mnf-t)" /> Personalized for your garden
        </p>

        {/* Save */}
        <Btn variant="primary" block size="lg">
          <Icon name="download" size={18} /> Save to phone
        </Btn>

        {/* Share row */}
        <div className="grid grid-cols-2 gap-2.5">
          <Btn variant="secondary" block><Icon name="share" size={16} /> Instagram</Btn>
          <Btn variant="secondary" block><Icon name="content_copy" size={16} /> Copy link</Btn>
        </div>

        <div className="mnf-divider-leaf" style={{ marginTop: 6 }}>
          <Icon name="eco" size={14} color="var(--mnf-t)" />
        </div>

        <p className="text-center text-xs mnf-body italic" style={{ color: "var(--mnf-tg)" }}>
          Each verse you share waters another sister's garden.
        </p>
      </div>
    </>
  );
}
